module.exports = __webpack_public_path__ + "static/media/favicon.7deb4339.ico";